import { render, staticRenderFns } from "./AmeliaLoginIframeLocalStorage.vue?vue&type=template&id=ff0b1e64"
import script from "./AmeliaLoginIframeLocalStorage.vue?vue&type=script&lang=js"
export * from "./AmeliaLoginIframeLocalStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports